import React, { useRef, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {
    setFreezeDragging,
    setSampleDragging,
    setFrozenTrackPlaying
} from 'actions/index.js';

const DOUBLE_CLICK_TIME = 200;
const FreezeName = ({sample, setFreezeDragging, setSampleDragging}) => { 
    const lastClick = useRef(undefined);
    const [name, setName] = useState(sample.name);
    const [editing, setEditing] = useState(false);

    const onClick = useCallback(() => {
        if (editing) {
            return;
        }
        let now = new Date().getTime();
        if (lastClick.current && now - lastClick.current <= DOUBLE_CLICK_TIME) {
            setEditing(true);
        }

        lastClick.current = now;
    }, [editing, setEditing]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            sample.name = name;
            setEditing(false);
        }
    }, [setEditing, sample, name]);

    return (
        <div
          draggable={true}
          onDragStart={() => {
              console.log("drag start setting sample dragging=", sample);
              setSampleDragging(sample);
              setFreezeDragging(sample.ipfsHash);
          }}
          onDragOver={(e) => e.preventDefault()}
          onClick={onClick}
          className="freeze-name">
          {editing ?
           <input
             type="text"
             value={name}
             onKeyDown={onKeyDown}
             onChange={(e) => setName(e.target.value)}
             className="freeze-name-edit"/> :
           name}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setFreezeDragging: (x) => dispatch(setFreezeDragging(x)),
      setSampleDragging: (x) => dispatch(setSampleDragging(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FreezeName);
